export default class ViewTableVO
{
	// Common properties for all fields
	
	// ----------------------------------
	//	Properties
	// ----------------------------------

	name = "Table";
	relevantDirection = 'vertical';
	//rows = 3;
	//cols = 3;
	rowOrCols = 3;
	stylingClass = ''; // dev property
	wrap = 'mobile'; // values: 'none', 'mobile', 'all'
	topRowEmphasis = true;
	endRowEmphasis = false;
	startColEmphasis = true;
	endColEmphasis = false;
	fullScreenAsCompleteTable = false;
	showInEditor = true;
	fieldType = 'table';
	uiComponent = 'view-table-field';
	description = 'A grid table';

	constructor()
	{
		
	}
}